import * as constants from 'constants/intl-constants';

import type {LocaleModule} from 'constants/intl-constants';
import type {IntlStore} from 'stores/intl-store';

export function setFormats(formats: IntlStore['formats']) {
    return {
        type: constants.SET_FORMATS,
        formats: formats,
    };
}

export function setMessages(moduleNames: LocaleModule[], messages: IntlStore['messages']) {
    return {
        type: constants.SET_MESSAGES,
        messages,
        moduleNames,
    };
}
